import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-detail-ods',
  templateUrl: './detail-ods.component.html',
  styleUrls: ['./detail-ods.component.css']
})
export class DetailOdsComponent {
  
  @Input() ods: any[] = [];
  @Input() odsClass: string[] = [];
  @Input() isOdsActive: boolean = false;

}
